import axios from 'axios';
import { API } from '@/config/api';

const state = {
    companies: [],
};

const getters = {
    getCompanies: (state) => state.companies,
};

const mutations = {
    setCompanies: (state, companies) => {
        state.companies = companies;
    },
};

const actions = {
    async fetchCompanies({ commit }) {
        try {
            const response = await axios.post(
                API.GET_COMPANIES,
                {
                    "token": "test",
                    "limit": 50,
                    "page": 1
                }
            );

            if (response.data.status) {
                commit('setCompanies', response.data.response.companies);
            } else {
                
            }
        } catch (error) {
            console.error('Error fetching companies:', error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
